import i18n from "@/libs/i18n";
import store from "@/store";
import { useToast } from "vue-toastification/composition";
import { ref, watch, computed } from '@vue/composition-api'
import axios from "axios";

export default function useEnrollmentsList() {
    const toast = useToast()
    const refEnrollmentListTable = ref(null)
    const perPage = ref(10)
    const totalEnrollments = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const studentFilter = ref(null)
    const courseFilter = ref(null)
    const groupFilter = ref(null)

    const studentsOptions = ref([])
    const coursesOptions = ref([])
    const groupOptions = ref([])

    const tableColumns = [
        { key:'code', label: i18n.t('Enrollment Code'), sortable: true},
        { key:'student', label: i18n.t('Student'), sortable: true },
        { key:'course', label: i18n.t('Course'), sortable: true},
        { key: 'duration', label: 'Duración' },
        { key: 'expiration_date', label: 'Próxima renovación' },
        { key: 'status', label: 'Estado' },
        { key:'actions', label: i18n.t('Actions') }
    ]

    const dataMeta = computed(() => {
        const localItemsCount = refEnrollmentListTable.value ? refEnrollmentListTable.value.localItems.length: 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalEnrollments.value,
        }
    });

    const refetchData = function() {
        refEnrollmentListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, studentFilter, courseFilter, groupFilter], () => {
        refetchData()
    })

    const fetchEnrollments = function(ctx, callback) {
        store.dispatch('enrollments/fetchEnrollments', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            student: studentFilter.value,
            course: courseFilter.value, 
            group: groupFilter.value,
            limit: 25
        })
        .then(response => {
            const { enrollments, total, students, courses, groups } = response.data
            enrollments.tax=enrollments.tax
            callback(enrollments)
            totalEnrollments.value = total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching enrollments list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    const fetchStudents=function () {
        axios.get("students", {limit: 25}).then((response)=> {
            studentsOptions.value=response.students;
        })
    }

    return {
        fetchEnrollments,
        fetchStudents,
        tableColumns,
        perPage,
        currentPage,
        totalEnrollments,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refEnrollmentListTable,
        refetchData,
        studentFilter,
        courseFilter,
        groupFilter,
        studentsOptions,
        coursesOptions,
        groupOptions
    }
}
